import $ from '@vaersaagod/tools/Dom';
import Flickity from 'flickity';

export default (el, props) => {
    const dom = $(el);
    const wrapper = dom.find('[data-slides]').get(0);
    let flkty = null;

    const init = () => {
        flkty = new Flickity(wrapper, {
            contain: true,
            dragThreshold: 15,
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: false,
            freeScroll: true,
            freeScrollFriction: 0.045
        });

        flkty.resize();

        flkty.on('dragStart', () => {
            document.ontouchmove = e => e.preventDefault();
        });

        flkty.on('dragEnd', () => {
            document.ontouchmove = () => true;
        });
    };

    const destroy = () => {};

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Slideshow.js